import { } from "jquery"
import { } from "bootstrap"
import { forEach, flatMap, groupBy, keyBy } from "lodash"
import * as uuid from "uuid"
import { QueryAsset, PagedListResult, ListResult, Asset, CreateAsset, AssetStatusEnum, Dict, Facility, QueryAssetOrderBy, AssetTypeEnum, ModelResult, UpdateAsset, Tablet } from "../api/model"
import { AssetCategoryApi, AssetAreaApi, FacilityApi, AssetApi, AssetLoanApi, AssetLoanHistoryLines, AssetLoanHistoryLine, TabletApi } from "../api/api"
import { UiUtils, JqElm, GeneralElementCreator } from "./ui"
import { PaginationUi } from "./pagination_ui"
import { splitIgnoreEmpty } from "../utils/string"
import { Pagination } from "../utils/pagination"
import { AssetEditPageBase } from "./asset_edit_page_base"
import { inspect } from "util"
import { strEqIgnoreEmptyAndNull } from "../utils/core"
import * as dateformat from "dateformat"
import { formatDate } from "../utils/date";


export class ListAssetPage extends AssetEditPageBase {
    private static readonly LoanDateFormat = "yyyy/mm/dd HH:MM"
    private static readonly DefaultMaxCount = 10
    private static readonly DefaultBucketSize = 5
    rootContainerId: string = "asset_list_container"
    private readonly assetItemElmCreator = new AssetItemElementCreator()
    private readonly assetEditItemElmCreator = new AssetEditItemElementCreator()
    private readonly assetLoanRecordElmCreator = new AssetLoanRecordElementCreator()
    private assetLoanHistoryLines: AssetLoanHistoryLines
    private assetMap: Dict<Asset> = {}
    private queryAsset: QueryAsset = {
        maxCount: ListAssetPage.DefaultMaxCount,
        orderBy: "displayId",
        orderByDescending: true
    }
    private pagination = new Pagination(ListAssetPage.DefaultMaxCount, ListAssetPage.DefaultBucketSize)
    private paginationUi: PaginationUi

    constructor(
        assetApi: AssetApi,
        assetCategoryApi: AssetCategoryApi,
        facilityApi: FacilityApi,
        assetAreaApi: AssetAreaApi,
        private tabletApi: TabletApi,
        private assetLoanApi: AssetLoanApi,
    ) {
        super(assetApi, assetCategoryApi, facilityApi, assetAreaApi)
    }

    initNoteModal() {
        super.initNoteEditModal()
        this.initNoteRoModal()
    }

    initPagination() {
        this.paginationUi = new PaginationUi($('#asset_list_pagination'), this.pagination, (offset) => {
            this.queryAsset.offset = offset
            this.queryAndFillAssets()
        })
    }

    async queryAndFillAssets(): Promise<void> {
        const queryAssetResp = await this.queryAssets()
        this.fillAssetListData(queryAssetResp.data)
        this.assetLoanHistoryLines = { linesMapByAsset: {}, tabletsMap: {} }
    }

    async queryAssetLoanHistoryLines(assetIds: Array<number>): Promise<void> {
        try {
            this.assetLoanHistoryLines= await this.assetLoanApi.queryAssetLoanHistoryLines(assetIds, this.tabletApi)
        } catch (err) {
            console.error('queryAssetLoanHistoryLines fail:', err)
        }
    }

    initLoanRecordModal() {
        const page = this
        const modal = $('#loan_record_modal')
        modal.on('show.bs.modal', function (event) {
            const button = $(event.relatedTarget)
            const recordId = button.data('id')
            modal.data('id', recordId)
            $("#loading_loan_record").show()
            page.queryAssetLoanHistoryLines([recordId])
                .then(() => {
                    $('#loan_status').val('all')
                    const loanLines = page.assetLoanHistoryLines.linesMapByAsset[recordId]
                    $(`.${page.assetLoanRecordElmCreator.classId}`).remove()
                    if (loanLines != null) {
                        loanLines.forEach(line => {
                            page.appendLoanRecordElm(recordId, line, page.assetLoanHistoryLines.tabletsMap)
                        })
                    }
                    $("#loading_loan_record").hide()
                })
                .catch(error => {
                    console.error('queryAssetLoanHistoryLines fail：', error)
                    $("#loading_loan_record").hide()
                })
        })

        modal.on('hidden.bs.modal', function () {
            page.assetLoanHistoryLines = { linesMapByAsset: {}, tabletsMap: {} }
            $('.asset_loan_record_item').remove()
        })
    }

    private initNoteRoModal() {
        const page = this
        const modal = $('#note_ro_modal')
        const noteArea = $('#note_ro')
        modal.on('show.bs.modal', function (event) {
            const button = $(event.relatedTarget)
            const recordId = button.data('id')
            modal.data('id', recordId)
            const asset = page.assetMap[recordId]
            const note = asset.note ? asset.note.replace(/(?:\r\n|\r|\n)/g, '<br />') : ''
            noteArea.html(note)
        })
    }

    listenExportClick() {
        $('.export_dropdown li').click(e => {
            switch ($(e.currentTarget).prop('id')) {
                case 'export_menu_opt_excel':
                    location.href = this.assetApi.getExportToExcelLink(this.queryAsset)
                    break
                case 'export_menu_opt_barcode':
                    this.gotoBarcode()
                    break
            }
        })
    }

    //#TODO - common function
    editItemToRawData<T>(editItemElm: JqElm, formalizeFunc: (t: T) => void, ignore_elm_names: Array<string> = []): T {
        const data: any = {}
        //const final_ignore_elm_names = ignore_elm_names.concat([''])
        editItemElm
            .find('input, select')
            .toArray()
            .map($)
            .map(it => {
                return { 'elm': it, 'name': it.prop('name').toString() }
            })
            .filter(it => !ignore_elm_names.includes(it.name))
            .forEach(it => {
                const elm = it.elm
                const name = it.name
                if (name.startsWith('type_')) {
                    if (UiUtils.isChecked(elm)) {
                        data['type'] = elm.val()
                    }
                } else {
                    if (name == 'guestLoanable') {
                        data[name] = UiUtils.isChecked(elm)
                    } else {
                        data[name] = elm.val()
                    }
                }
            })
        formalizeFunc(data)
        console.log("Final data to update:%s", inspect(data))
        return data
    }
    private formalizeCommonAssetData(assetData: any) {
        Object.entries(assetData).forEach(([k, v]) => {
            switch (k) {
                case 'communityAssignId':
                case 'note':
                    assetData[k] = v.length == 0 ? null : v
                    break
                case 'categoryId':
                    assetData[k] = v == null ? null : Number(v)
                    break
                case 'quantity':
                    assetData[k] = Number(v)
                    break
                case 'areaId':
                    v = Number(v)
                    assetData[k] = v == -1 ? null : v
                    break
                case 'facilityIds':
                    assetData[k] = v.length == 0 ? null : splitIgnoreEmpty(v, ',')
                    break
            }
        })
    }

    listenItemUpdateClick() {
        $(document).on('click', '[name=edit_confirm]', e => {
            e.preventDefault()
            const editItemElm = $(e.currentTarget).parents(`.${this.assetEditItemElmCreator.classId}`)
            if (this.validateItemData(editItemElm)) {
                const assetId = editItemElm.data('id')
                const asset = this.assetMap[assetId]
                const updateAsset: UpdateAsset = this.editItemToRawData(editItemElm, this.formalizeCommonAssetData, ['check', 'categoryRootId'])
                const nameChange = !strEqIgnoreEmptyAndNull(updateAsset.name, asset.name)
                const idChange = !strEqIgnoreEmptyAndNull(updateAsset.communityAssignId, asset.communityAssignId)
                if (nameChange || idChange) {
                    const changes = []
                    if (nameChange) changes.push("資產名稱")
                    if (idChange) changes.push("社區財產編號")
                    const colName = changes.join('、')
                    UiUtils.confirm(`異動項目為【${colName}】，若修改將導致已列印的標籤和後台資料不一致，是否確認編輯？`).then(confirm => {
                        if (confirm) {
                            editItemElm.remove()
                            this.updateAndFillAsset(assetId, updateAsset)
                        }
                    })
                } else {
                    editItemElm.remove()
                    this.updateAndFillAsset(assetId, updateAsset)
                }
            }
        })
    }

    private async updateAsset(assetId: string, updateAsset: UpdateAsset): Promise<Asset> {
        try {
            const resp = await this.assetApi.update(assetId, updateAsset)
            const asset = resp.data
            this.assetMap[asset.id] = asset
            return asset
        } catch (e) {
            UiUtils.alertIfClientError(e)
        }
    }

    private updateAndFillAsset(assetId: string, updateAsset: UpdateAsset): Promise<Asset> {
        const elm = this.elmById(assetId, this.assetItemElmCreator.classId)
        return this.updateAsset(assetId, updateAsset).then(asset => {
            console.log("Update asset result:%s", inspect(asset, false, 2))
            this.fillAssetData(asset, elm)
            return asset
        })
    }

    queryAssets(): Promise<PagedListResult<Asset>> {
        const promise = this.assetApi.query(this.queryAsset)
        promise.then(resp => {
            this.pagination.updateByOffset(resp.total, resp.offset)
            this.assetMap = {}
            resp.data.forEach(asset => {
                this.assetMap[asset.id] = asset
            })
        })
        return promise
    }

    private queryAssetForBarcode(): Promise<Array<PagedListResult<Asset>>> {
        const total = this.pagination.total
        const maxCount = 100
        const promises: Array<Promise<PagedListResult<Asset>>> = []
        let offset = 0
        do {
            const queryAsset: QueryAsset = Object.assign({}, this.queryAsset, {
                offset: offset,
                maxCount: maxCount
            })
            console.log("Query: %s", inspect(queryAsset, false, 2))
            promises.push(this.assetApi.query(queryAsset))
            offset += maxCount
        } while (offset < total)
        return Promise.all(promises)
    }

    async gotoBarcode() {
        const sid = uuid()
        const url = 'assetBarcode.aspx?id=' + sid
        const page = window.open(url, '_blank')
        const results = await this.queryAssetForBarcode()
        console.log("Requests:%s", results.length)
        const barcodeData = flatMap(
            results.map(it => it.data.map(asset => {
                return {
                    areaName: this.assetBasicDataProvider.getAreaName(asset.areaId),
                    displayId: asset.displayId,
                    name: asset.name,
                    communityAssignId: asset.communityAssignId
                }
            }))
        )
        console.log("Results:%s", barcodeData.length)

        const skey = 'barcode_tmp'
        const commKey = 'community_info'
        let dataStr = localStorage.getItem(skey)
        let commStr = localStorage.getItem(commKey)
        if (dataStr == null) {
            dataStr = '{}'
            localStorage.setItem(skey, dataStr)
        }
        //每次直接取得最新社區名稱
        //if (commStr == null) {
            localStorage.setItem(commKey, JSON.stringify({
                'name': this.getCommName()
            }))
        //}
        const data = JSON.parse(dataStr)
        data[sid] = barcodeData
        localStorage.setItem(skey, JSON.stringify(data))
        page.location.href = url
    }

    //TODO - migrated
    initCodeScan() {
        this.listenCodeScanClick()
    }

    private getStatusFilterValue(statusFilterElm: JqElm): AssetStatusEnum | null {
        const statusVal = statusFilterElm.val()
        return statusVal != "" ? <AssetStatusEnum>statusVal : null
    }

    /*
    listenStatusFilterChange() {
        this.elmById('search', null, 'status').change(e => {
            this.queryAsset.status = this.getStatusFilterValue($(e.currentTarget))
            this.queryAndFillAssets()
        })
    }
    */

    //TODO - migrated
    private listenScanCodeInput(inputElm: JqElm, modalElm: JqElm) {
        const fakeInputElm = modalElm.find('.fakeInput').html('請輸入條碼')
        inputElm
            .val('').focus().off('keyup').off('blur')
            .keyup(e => {
                console.log("keyup")
                const elm = $(e.currentTarget)
                if (e.keyCode == 13) {
                    modalElm.hide()
                } else {
                    elm.focus()
                    this.elmById('search', null, 'id').val(elm.val())
                    fakeInputElm.text(<string>elm.val())
                }
            }).blur(e => {
                console.log("Blur")
                const elm = $(e.currentTarget)
                elm.val('').focus()
            })
    }


    private fillAssetData(asset: Asset, assetElm: JqElm) {
        assetElm.show()
        const id = assetElm.data('id')
        this.elmById(id, 'item_displayId').text(asset.displayId)
        this.elmById(id, "item_name").text(asset.name)
        const notAllReturn = asset.loan > 0
        let statusText = this.statusNameMap[asset.status]
        if (notAllReturn) {
            let remaining = asset.quantity - asset.loan
            this.elmById(id, "item_remaining").text(`現有 ${remaining} 個`).show()
            //Remove delete button
            this.elmById(id, 'item_delete').remove()
            assetElm.find('.edit_sep').remove()
            this.elmById(id, null, 'check').parent('.cr-styled').remove()
            if(remaining > 0){
                statusText += '<br>(部分物品借出中)'
            }
        }
        this.elmById(id, "item_status").html(statusText)
        this.elmById(id, "item_quantity").text(`原有 ${asset.quantity} 個`)
        this.elmById(id, 'item_communityAssignId').text(asset.communityAssignId != null ? asset.communityAssignId : '')
        const catName = this.assetBasicDataProvider.getCategoryName(asset.categoryId)
        this.elmById(id, 'item_category').text(catName)
        this.elmById(id, "item_area").text(this.assetBasicDataProvider.getAreaName(asset.areaId))
        if (asset.type == 'fixed') {
            this.elmById(id, 'item_type').text('固定資產')
        } else {
            this.elmById(id, 'item_type').text('一般資產')
            if (asset.facilityIds != null && asset.facilityIds.length != 0) {
                this.elmById(id, 'item_facilityEnable').show()
                const facilityIds = new Set(asset.facilityIds)
                const facilityNames = this.assetBasicDataProvider.facilities.filter(it => facilityIds.has(it.id)).map(it => it.name)
                this.elmById(id, 'item_facilities').text(facilityNames.join(","))
            } else {
                this.elmById(id, 'item_facilityEnable').hide()
                this.elmById(id, 'item_facilities').text('')
            }
        }
        this.elmById(id, 'item_guestLoanable').toggle(asset.guestLoanable)
    }

    fillAssetListData(assets: Array<Asset>) {
        this.paginationUi.refresh()
        $(`.${this.assetItemElmCreator.classId}`).remove()
        $(`.${this.assetEditItemElmCreator.classId}`).remove()
        assets.forEach(asset => {
            //console.log("Fill asset item:%s", inspect(asset))
            const elm = this.appendAssetItemElm(asset.id.toString())
            this.fillAssetData(asset, elm)
        })
        //super.fillAssetData(assets, this.appendAssetItemElm.bind(this))
    }

    listenCleanFilterClick() {
        $('#clean_filter').click(e => {
            this.elmById("search", null, "name").val('')
            this.elmById("search", null, "status").val('')
            this.elmById("search", null, "id").val('')
            this.elmById("search", null, "categoryRootId").val('').change()
            this.elmById("search", null, "areaId").val('').change()
            UiUtils.setChecked(this.elmById("search", null, "type_search"), false).change()
            UiUtils.setChecked(this.elmById("search", null, "guestLoanable"), false).change()
            UiUtils.setChecked(this.elmById("search", null, "facilityEnable"), false).change()
            this.queryByFilterElms()
        })
    }

    listenSortChange() {
        const sortableElms = $('[class^=head_sort]')
        sortableElms.click(e => {
            const elm = $(e.currentTarget)
            //Get current sort status
            const reverseSorted = elm.hasClass('sorttable_sorted_reverse')
            const sorted = elm.hasClass('sorttable_sorted')
            //Clean all sort status
            sortableElms.removeClass('sorttable_sorted_reverse').removeClass('sorttable_sorted')
            //Get sort name
            const sortName = [
                'head_sort_displayId',
                'head_sort_status',
                'head_sort_categoryId'
            ]
                .filter(className => elm.hasClass(className))
                .map(it => it.replace('head_sort_', ''))[0]
            this.queryAsset.orderByDescending = false
            if (sorted || reverseSorted) {
                this.queryAsset.orderByDescending = reverseSorted ? false : true
            }
            this.queryAsset.orderBy = <QueryAssetOrderBy>sortName
            elm.addClass(this.queryAsset.orderByDescending ? 'sorttable_sorted_reverse' : 'sorttable_sorted')
            this.queryAndFillAssets()
        })
    }

    queryByFilterElms() {
        const nameVal = <string>this.elmById("search", null, "name").val()
        const idVal = <string>this.elmById("search", null, "id").val()
        const facilityIdVal = splitIgnoreEmpty(<string>this.elmById("search", null, "facilityIds").val(), ',')
        const categoryIdVal = this.elmById("search", null, "categoryId").val()
        const areaIdVal = Number(this.elmById("search", null, "areaId").val())
        const typeVal = <AssetTypeEnum>this.elmById("search", null, "type_search", ':checked').val()
        const guestLoanableVal = Boolean(this.elmById("search", null, "guestLoanable", ":checked").val())
        const facilityEnableVal = Boolean(this.elmById("search", null, "facilityEnable", ":checked").val())
        const statusVal = <string>this.elmById("search", null, "status").val()
        this.queryAsset.offset = 0
        this.queryAsset.name = nameVal.length != 0 ? nameVal : null
        this.queryAsset.displayId = idVal.length != 0 ? idVal : null
        this.queryAsset.facilityIds = facilityIdVal.length != 0 ? facilityIdVal : null
        this.queryAsset.areaId = areaIdVal != 0 ? areaIdVal : null
        this.queryAsset.type = typeVal
        this.queryAsset.guestLoanable = guestLoanableVal ? true : null
        this.queryAsset.status = statusVal != "" ? <AssetStatusEnum>statusVal : null
        if (categoryIdVal != null) {
            let cats = [Number(categoryIdVal)]
            if (categoryIdVal == 0) {
                const rootCatId = Number(this.elmById('search', null, 'categoryRootId').val())
                cats = this.assetBasicDataProvider.catParentMap.get(rootCatId).map(it => it.id)
            }
            this.queryAsset.categoryIds = cats
        } else {
            if (this.elmById("search", null, "categoryRootId").val() == '-1') {
                this.queryAsset.categoryIds = [-1]
            } else {
                this.queryAsset.categoryIds = null
            }
        }
        this.queryAsset.withFacility = facilityEnableVal ? true : null
        console.log("Query for assets:%s", inspect(this.queryAsset, null, 2))
        this.queryAndFillAssets()
    }

    listenSearchClick() {
        $('#search').click(e => {
            this.queryByFilterElms()
        })
    }

    listenEditClick() {
        $(document).on('click', `.${this.assetItemElmCreator.classId} .item_edit`, e => {
            e.preventDefault()
            const el = $(e.target)
            const itemElm = el.parents(`.${this.assetItemElmCreator.classId}`)
            itemElm.hide()
            const assetId = el.data('id')
            const asset = this.assetMap[assetId]
            const editElm = super.fillEditAssetData([asset], this.insertEditAssetItemElm.bind(this, itemElm), true)[0]
            if (asset.status == 'loan') {
                editElm.find('[name=status]').hide()
                editElm.find('.status_text').text('借出').show() //TODO 
            } else {
                editElm.find('[name=status] [value=loan]').remove()
                editElm.find('[name=status]').show()
            }
            if (asset.areaId == null) {
                this.elmById(assetId, null, "area").val('-1').change()
            }
        })
    }

    listenCancelEditClick() {
        $(document).on('click', `.${this.assetEditItemElmCreator.classId} [name=edit_cancel]`, e => {
            e.preventDefault()
            const el = $(e.target)
            const itemElm = el.parents(`.${this.assetEditItemElmCreator.classId}`)
            itemElm.prev().show()
            itemElm.remove()
        })
    }

    private insertEditAssetItemElm(insertAfterElm: JqElm, id?: string): JqElm {
        id = id ? id : uuid()
        const templateData = {
            id: id
        }
        const elm = this.assetEditItemElmCreator.createJqElm(templateData)
        this.fillCategoryElmData(
            elm.find('select[name=categoryRootId]'),
            elm.find('select[name=categoryId]')
        )
        this.fillAreaElmData(elm.find('select[name=areaId]'))
        elm.insertAfter(insertAfterElm)
        return elm
    }

    private appendAssetItemElm(id?: string): JqElm {
        id = id ? id : uuid()
        const templateData = {
            id: id
        }
        const elm = this.assetItemElmCreator.createJqElm(templateData)
        elm.appendTo($(this.assetItemElmCreator.tmplElmId).parent())
        return elm
    }

    listenLoanRecordStatusChange() {
        $('#loan_status').change(e => {
            const elm = $(e.target)
            const val = elm.val()
            const noNeedReturnElms = $(`.${this.assetLoanRecordElmCreator.classId}[data-need-return-quantity="0"]`)
            if (val == 'all') {
                $(`.${this.assetLoanRecordElmCreator.classId}`).show()
            } else {
                noNeedReturnElms.hide()
            }
        })
    }

    listenLoanReturnBtn() {
        $(document).on('click', '#return_asset_btn', e => {
            const elm = $(e.target)
            this.returnAsset(elm)
        })
    }

    private async returnAsset(elm: JqElm) {
        const assetId = elm.data('asset-id')
        const loanId = elm.data('loan-id')
        const loanDate = elm.data('loan-date')
        const asset = this.assetMap[assetId]
        const needReturnQuantity = elm.data('need-return-quantity')
        const targetType = elm.data('target-type')
        const target = elm.data('target')
        let targetName = '訪客'
        if (targetType == 'tablet') {
            targetName = `住戶「${decodeURIComponent(target)}」`
        }
        const confirmMsg = `確定歸還「${needReturnQuantity}」個, ${targetName}於「${loanDate}」借出的資產「${asset.name}」嗎？`
        const confirm = await UiUtils.confirm(confirmMsg)
        if (confirm) {
            $('#loan_record_modal').modal('toggle');
            try {
                await this.assetLoanApi.update(loanId, {
                    returnHistories: [{
                        assetId: assetId,
                        quantity: needReturnQuantity
                    }]
                })
            } catch (e) {
                UiUtils.alertIfClientError(e)
            }
            await this.queryAndFillAssets()
        }
    }

    private appendLoanRecordElm(assetId: number, line: AssetLoanHistoryLine, tabletsMap: Dict<Tablet>): JqElm {
        //console.log("line:%s", inspect(line, false, 5))
        const targetType = line.tabletId != null ? 'tablet' : 'guest'
        let target = '訪客'
        if (targetType == 'tablet') {//TODO
            target = tabletsMap[line.tabletId].note
        }
        const templateData = {
            targetType: targetType,
            assetId: assetId,
            id: uuid(),
            loanId: line.loanId,
            needReturnQuantity: line.needReturnQuantity,
            loanDate: formatDate(line.loanDate),
            target: target,
            encodedTarget: encodeURIComponent(target),
            quantity: line.quantity,
            returnBtnDisplay: line.needReturnQuantity == 0 ? 'none' : '',
            returnDate: line.needReturnQuantity == 0 ? formatDate(line.allReturnDate) : '',
            note: line.needReturnQuantity != 0 ? `已歸還${line.returnQuantity}個` : ''
        }
        const elm = this.assetLoanRecordElmCreator.createJqElm(templateData)
        elm.appendTo($(this.assetLoanRecordElmCreator.tmplElmId).parent())
        return elm
    }

    private getDeleteConfirmDialog(assets: Array<Asset>): Promise<boolean> {
        let message = '確定要刪除此資產項目嗎？<ul>'

        message += assets.map(asset => {
            const displayId = asset.communityAssignId != null ? asset.communityAssignId : asset.displayId
            const areaName =  this.assetBasicDataProvider.getAreaName(asset.areaId)
            const categoryName = this.assetBasicDataProvider.getCategoryName(asset.categoryId)
            return `<li>${displayId} ${asset.name}/${areaName}/${categoryName}</li>`
        }).join('')
        message += '</li>'
        return UiUtils.confirm(message)
    }

    listenDeleteClick() {
        $('#delete_btn').click(e => {
            const assetIds = $('[name=check]:checked').parents('.asset_item,.asset_edit_item').toArray().map(it => Number($(it).data('id')))
            if (assetIds.length != 0) {
                const assets = assetIds.map(it => this.assetMap[it])
                this.getDeleteConfirmDialog(assets).then(confirm => {
                    if (confirm) {
                        this.deleteAssets(assetIds).then(() => {
                            UiUtils.setChecked($('[name=check_all]'), false)
                            this.refreshAfterDeleteIfNeed().then(refresh => {
                                if (!refresh) {
                                    assetIds.map(it => $(`[data-id=${it}]`)).forEach(elm => {
                                        elm.remove()
                                    })
                                }
                            })
                        })
                    }
                })
            }
        })
    }
    listenItemDeleteClick() {
        $(document).on('click', '.item_delete', e => {
            e.preventDefault()
            const elm = $(e.currentTarget)
            const id = elm.data('id')
            const asset = this.assetMap[id]
            const displayId = asset.communityAssignId != null ? asset.communityAssignId : asset.displayId
            const assetIds = [Number(elm.data('id'))]

            this.getDeleteConfirmDialog([asset]).then(confirm => {
                if (confirm) {
                    this.deleteAssets(assetIds).then(() => {
                        this.refreshAfterDeleteIfNeed().then(refresh => {
                            if (!refresh) {
                                elm.parents(`.${this.assetItemElmCreator.classId}`).remove()
                            }
                        })
                    })
                }
            })
        })
    }

    private async refreshAfterDeleteIfNeed(): Promise<boolean> {
        const currentAssetSize = Object.keys(this.assetMap).length
        const pageCount = this.pagination.pageCount
        console.log("Current asset:%s - page count:%s", currentAssetSize, pageCount)
        if (currentAssetSize == 0 && pageCount > 1) {
            if (!this.pagination.hasNextPage) { //Go to previous page
                console.log("No next page, shoud go to previous page")
                this.queryAsset.offset = this.pagination.offset - this.pagination.pageSize
            }
            await this.queryAndFillAssets()
            return true
        } else {
            return false
        }
    }

    private async deleteAssets(assetIds: Array<number>) {
        const promise = this.assetApi.delete({
            ids: assetIds
        })
        promise.then(() => {
            assetIds.forEach(id => {
                delete this.assetMap[id]
            })
        })
        return promise
    }

    listenCheckAllClick() {
        $('[name=check_all]').change(e => {
            const checked = UiUtils.isChecked($(e.currentTarget))
            UiUtils.setChecked($('[name=check]'), checked)
        })
    }

    //TODO - migrated
    private listenCodeScanClick() {
        const modal = $('#code_scan_modal')
        const manualModal = $('#code_scan_manual_modal')
        modal.find('.icon-close').click(() => {
            modal.hide()
        })
        manualModal.find('.icon-close').click(() => {
            manualModal.hide()
        })
        $('#code_scan_manual_modal_confirm').click(() => {
            manualModal.hide()
        })
        $('#code_scan_manual_btn').click(() => {
            manualModal.show()
            modal.hide()
            this.listenScanCodeInput(manualModal.find('[type=password]:first'), manualModal)
        })
        $('#id_scan').click(() => {
            modal.show()
            this.listenScanCodeInput(modal.find('[type=password]:first'), modal)
        })
    }

    updateBackPageLink() {
        $('#backpage').prop('href', 'assetMain.aspx')
    }

    //#TODO - Migrated
    initSearchElms() {
        const rootCatSelectElm = this.elmById("search", null, "categoryRootId")
        this.fillCategoryElmData(
            rootCatSelectElm,
            this.elmById("search", null, "categoryId")
        )
        rootCatSelectElm.append(UiUtils.options("待分類", "-1"))
        const areaSelectElm = this.elmById("search", null, "areaId")
        this.fillAreaElmData(areaSelectElm)
        this.appendOtherAreaOption(areaSelectElm)
    }

}

class AssetItemElementCreator extends GeneralElementCreator {
    classId: string = 'asset_item'
}

class AssetEditItemElementCreator extends GeneralElementCreator {
    classId: string = 'asset_edit_item'
}

class AssetLoanRecordElementCreator extends GeneralElementCreator {
    classId: string = 'asset_loan_record_item'
}